module.exports = __webpack_public_path__ + "static/media/thumb_KPDQ2667_1024.29648558.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/thumb_KPDQ2667_1024.jpg
// module id = 136
// module chunks = 0